module.exports = __webpack_public_path__ + "static/media/foodpanda_logo.c9b779b6.jpg";